// extracted by mini-css-extract-plugin
module.exports = {"root":"Banners_root__6I4W4","banner":"Banners_banner__w67yr","controls":"Banners_controls__zW94C"};